<template>
  <div>
    <template v-if="$route.path === '/user/add'">
      <UserForm />
    </template>
    <template v-if="$route.path === '/user/parents'">
      <ParentFormContainer :forClient="true" />
    </template>
    <template v-if="$route.path === '/user/payment'">
      <PaymentForm :forClient="true" :activeSub="activeSub" :groupRedirect="!!activeGroup"/>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import UserForm from '../../components/Forms/UserForm'
import ParentFormContainer from '../../components/Forms/ParentFormContainer'
import PaymentForm from '../../components/Forms/PaymentForm'

export default {
  name: 'AddUser',
  components: {
    UserForm,
    ParentFormContainer,
    PaymentForm
  },
  methods: {
    ...mapActions(['resetUsers'])
  },
  computed: {
    ...mapGetters(['groups', 'activeGroup']),
    activeSub() {
      if (this.groups && this.groups.data) {
        const group = this.groups.data.find(g => g._id === this.activeGroup)
        return group && group.stripeId
      }
    }
  },
  mounted() {
    // So payment doesn't load in bulk amount
    this.resetUsers()
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AddUser/AddUser.vue?27078c08